import { StateInterface } from '../store';
import { Store } from 'vuex';

export default class GoogleTagManager {
  static Install(store: unknown): void {

    const typedStore = store as Store<StateInterface>;

    let tagId = process.env.HRV_TagID; 
    switch (typedStore.state.setting.company) {
      case 'CRV':
        tagId = process.env.CRV_TagID;
        break;
      case 'DRV':
        tagId = process.env.DRV_TagID;
        break;
      default:
        tagId = process.env.HRV_TagID;
        break;
    }

    const googleTagInstall = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${<string>tagId}');`    

    const googleTagManager = document.getElementById('google-tag-manager');

    if(googleTagManager){
      googleTagManager.append(googleTagInstall);
    }
  }
}
